<template>
  <div>
    <taskToday3 v-if="$root.profile.role !== 11000" />
  </div>
</template>

<script>
export default {
  components: {
    taskToday3: () => import("./w/tasksToday3.vue"),
  },
  data() {
    return {};
  },
  created() {
    this.$root.title = "Главная";
  },
  methods: {},
};
</script>
